import { ViewportScroller } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Router, Scroll } from '@angular/router';
import { Event } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Injectable()
export class CourseSearchScrollerService {
	private _router = inject(Router);
	private _viewportScroller = inject(ViewportScroller);
	private _initialLoad = true;

	private _routerSub!: Subscription;

	constructor() {
		this._viewportScroller.setHistoryScrollRestoration('manual');
	}

	init() {
		this._routerSub = this._router.events
			.pipe(filter((e: Event): e is Scroll => e instanceof Scroll))
			.subscribe(() => {
				if (!this._initialLoad) {
					setTimeout(() => {
						this._viewportScroller.scrollToAnchor('course-search-container');
					}, 0);
				}
				this._initialLoad = false;
			});
	}

	resetInitialLoad() {
		this._initialLoad = true;
		this._routerSub.unsubscribe();
	}

	scrollToTop() {
		this._viewportScroller.scrollToPosition([0, 0]);
	}
}
